export type SubscriptionPeriod = "monthly" | "annually";

/**
 * Stripe Price IDs from STRIPE_ALLOWED_PRICE_IDS (bigdata-api env).
 * Verify interval in Stripe Dashboard → Products → Prices
 * (monthly ≈ 299 PLN, yearly ≈ 2399 PLN). Swap if checkout shows wrong amount.
 */
export const STRIPE_PRICE_IDS: Record<SubscriptionPeriod, string> = {
    monthly: "price_1TiUqMF7akTi8bBwjYnzmCpv",
    annually: "price_1TiUr1F7akTi8bBwvvnu8Iks"
};

export const getStripePriceId = (period: SubscriptionPeriod): string => STRIPE_PRICE_IDS[period];

export const buildCheckoutRedirectUrls = (returnUrl: string) => {
    const cancelUrl = new URL(returnUrl);
    cancelUrl.searchParams.delete("subscription");

    const successUrl = new URL(returnUrl);
    successUrl.searchParams.set("subscription", "success");

    return {
        success_url: successUrl.toString(),
        cancel_url: cancelUrl.toString()
    };
};

export const FREE_PLAN_FEATURE_KEYS = [
    "newshub.paywall.modal.plans.free.features.1",
    "newshub.paywall.modal.plans.free.features.2",
    "newshub.paywall.modal.plans.free.features.3",
    "newshub.paywall.modal.plans.free.features.4"
] as const;

export const PAID_PLAN_FEATURE_KEYS = [
    "newshub.paywall.modal.plans.paid.features.1",
    "newshub.paywall.modal.plans.paid.features.2",
    "newshub.paywall.modal.plans.paid.features.3",
    "newshub.paywall.modal.plans.paid.features.4",
    "newshub.paywall.modal.plans.paid.features.5",
    "newshub.paywall.modal.plans.paid.features.6",
    "newshub.paywall.modal.plans.paid.features.7",
    "newshub.paywall.modal.plans.paid.features.8"
] as const;
